<template>
  <div class="form-view__powered-by">
    Powered by
    <a
      href="https://vokalis.ai"
      target="_blank"
      title="Vokalis Connect - no-code database tool"
    >
      <Logo
        class="form-view__powered-by-logo"
        alt="Vokalis Connect - no-code database tool"
      />
    </a>
  </div>
</template>
